import React from 'react'
import { ConfigProvider, Skeleton } from 'antd';

const CategoryCardSkeleton: React.FC = () => {
    return (

        <ConfigProvider
            theme={{
                components: {
                    Skeleton: {
                        gradientFromColor: "#404040",
                        gradientToColor: "#606060"
                    },
                },
            }}>

            <div className="bg-[#1E1E1E] rounded-lg gap-[8px] p-4 flex flex-col  h-[128px] justify-center items-center">

                <Skeleton.Avatar style={{ width: "30px", height: "30px" }} active />
                <Skeleton.Button style={{ width: "75px", height: "10px", marginTop: "8px" }} active />

            </div>
        </ConfigProvider>

    )
}

export default CategoryCardSkeleton